import {
  IconBatterier,
  IconElektronik,
  IconGlasFargat,
  IconGlasOfargat,
  IconHushallsavfall,
  IconKontorspapper,
  IconLampor,
  IconLysror,
  IconMatavfall,
  IconMetall,
  IconPapperForpackningar,
  IconPlastForpackningar,
  IconSekretess,
  IconTonerKassetter,
  IconWellpappKartong,
} from 'assets/icons';

const Materials = [
  {
    icon: IconPapperForpackningar,
    type: 'Pappersförpackningar',
    selected: true,
    details: [
      'Flingpaket',
      'Pappersmuggar, ursköljda',
      'Kartonger från färdigmat',
      'Mjölk- & juicepaket, ursköljda',
      'Papperspåsar',
      'Leksakskartonger',
      'Wellpappförpackningar',
    ],
  },
  {
    icon: IconPlastForpackningar,
    type: 'Plastförpackningar',
    selected: true,
    details: [
      'Plastflaskor & dunkar',
      'Burkar & lock/korkar',
      'Plastfilm/folie',
      'Bärkassar & plastpåsar',
      'Chips- & godispåsar',
    ],
  },
  {
    icon: IconMetall,
    type: 'Metallförpackningar',
    selected: true,
    details: ['Konservburkar', 'Kapsyler', 'Lock', 'Matförpackning av aluminium'],
  },
  {
    icon: IconKontorspapper,
    type: 'Kontorspapper',
    selected: true,
    details: [
      'Dator- och kopieringspapper',
      'Dags- och veckotidningar',
      'Reklam',
      'Broschyrer',
      'Kataloger',
      'Kuvert',
    ],
  },
  {
    icon: IconSekretess,
    type: 'Sekretesspapper',
    selected: false,
    details: [
      'Konfidentiella dokument',
      'Handlingar som innehåller känslig information',
      'Offerter, fakturor, avtalsförslag, ritningar och lönelistor',
    ],
  },
  {
    icon: IconMatavfall,
    type: 'Matavfall',
    selected: false,
    details: [
      'Frukt',
      'Grönsaker',
      'Matrester',
      'Bröd',
      'Kaffesump & filter',
      'Äggskal',
      'Hushållspapper',
    ],
  },
  {
    icon: IconWellpappKartong,
    type: 'Wellpapp',
    selected: false,
    details: ['Wellpappförpackningar', 'Annan ren karton'],
  },
  {
    icon: IconPlastForpackningar,
    type: 'Mjukplast (LDPE)',
    selected: false,
    details: ['Krymp & sträckfilm (LDPE)'],
  },
  {
    icon: IconGlasFargat,
    type: 'Färgade glasförpackningar',
    selected: false,
    details: ['Färgade glasflaskor', 'Färgade glasburkar'],
  },
  {
    icon: IconGlasOfargat,
    type: 'Ofärgade glasförpackningar',
    selected: false,
    details: ['Ofärgade glasflaskor', 'Ofärgade glasburkar'],
  },
  {
    icon: IconHushallsavfall,
    type: 'Restavfall',
    selected: false,
    details: ['Sanitetsprodukter', 'Pennor', 'Disktrasor', 'Diskborstar', 'Snus', 'Ätpinnar'],
  },
  {
    icon: IconElektronik,
    type: 'Elektronik',
    selected: false,
    details: [
      'Datorer',
      'Mikrovågsugn',
      'Brödrost',
      'Mobiltelefon',
      'Datorskärmar',
      'Enheter med batteri',
      'Enheter med sladd',
    ],
  },
  {
    icon: IconTonerKassetter,
    type: 'Toner & färgpatroner',
    selected: false,
    details: ['Förbrukade bläck- och lasertoners från kopiatorer och skrivare'],
  },
  {
    icon: IconLampor,
    type: 'Ljuskällor',
    selected: false,
    details: [
      'Glödlampor',
      'Halogenlampor',
      'Lågenergilampor',
      'LED-lampor',
      'Lysrör kortare än 60 cm',
    ],
  },
  {
    icon: IconLysror,
    type: 'Lysrör',
    selected: false,
    details: ['Raka lysrör längre än 60 cm'],
  },
  {
    icon: IconBatterier,
    type: 'Småbatterier',
    selected: false,
    details: [
      'Alla småbatterier inklusive små stavbatterier & knappcellsbatterier som innehåller litium',
    ],
  },
];

export default Materials;
